import { useEffect, useState, type ReactElement } from 'react';
import type { AmbienteInfo } from '@zenda/api-contract';
import { carregarAmbiente } from '../lib/rastreio';
import { useT } from '../lib/i18n';

/** Em produção não aparece nada. Fora dela, ninguém confunde o ambiente de testes com o real. */
export function FaixaDeAmbiente(): ReactElement | null {
  const t = useT();
  const [ambiente, setAmbiente] = useState<AmbienteInfo | null>(null);
  useEffect(() => {
    void carregarAmbiente().then(setAmbiente);
  }, []);
  if (ambiente === null || ambiente.env === 'production') return null;
  return (
    <div className={`faixa-ambiente faixa-ambiente--${ambiente.env}`} role="status">
      {ambiente.env === 'staging' ? t.ambiente.staging : t.ambiente.local} ·{' '}
      {ambiente.release.slice(0, 7)}
    </div>
  );
}
